import type { HelpSlug } from "../../articles";
import admin from "./admin.md" with { type: "text" };
import adminAccess from "./admin-access.md" with { type: "text" };
import adminCompany from "./admin-company.md" with { type: "text" };
import adminContentSafety from "./admin-content-safety.md" with { type: "text" };
import adminFeedback from "./admin-feedback.md" with { type: "text" };
import adminGovernance from "./admin-governance.md" with { type: "text" };
import adminIntegrations from "./admin-integrations.md" with { type: "text" };
import adminLicense from "./admin-license.md" with { type: "text" };
import adminModels from "./admin-models.md" with { type: "text" };
import adminUsage from "./admin-usage.md" with { type: "text" };
import adminUsers from "./admin-users.md" with { type: "text" };
import agentsAndModels from "./agents-and-models.md" with { type: "text" };
import apps from "./apps.md" with { type: "text" };
import brands from "./brands.md" with { type: "text" };
import build from "./build.md" with { type: "text" };
import buildAgents from "./build-agents.md" with { type: "text" };
import chat from "./chat.md" with { type: "text" };
import chatFiles from "./chat-files.md" with { type: "text" };
import concepts from "./concepts.md" with { type: "text" };
import connectGithub from "./connect-github.md" with { type: "text" };
import connectHubspot from "./connect-hubspot.md" with { type: "text" };
import connectLinear from "./connect-linear.md" with { type: "text" };
import connectSlack from "./connect-slack.md" with { type: "text" };
import connectZoominfo from "./connect-zoominfo.md" with { type: "text" };
import connectors from "./connectors.md" with { type: "text" };
import dataSources from "./data-sources.md" with { type: "text" };
import faqAccess from "./faq-access.md" with { type: "text" };
import faqLimits from "./faq-limits.md" with { type: "text" };
import faqTroubleshooting from "./faq-troubleshooting.md" with { type: "text" };
import feedback from "./feedback.md" with { type: "text" };
import firstChat from "./first-chat.md" with { type: "text" };
import knowledge from "./knowledge.md" with { type: "text" };
import knowledgeInbox from "./knowledge-inbox.md" with { type: "text" };
import navigation from "./navigation.md" with { type: "text" };
import notifications from "./notifications.md" with { type: "text" };
import pastChats from "./past-chats.md" with { type: "text" };
import projectsAndTeams from "./projects-and-teams.md" with { type: "text" };
import settings from "./settings.md" with { type: "text" };
import sharing from "./sharing.md" with { type: "text" };
import skills from "./skills.md" with { type: "text" };
import spaceMembers from "./space-members.md" with { type: "text" };
import spaceSettings from "./space-settings.md" with { type: "text" };
import spaces from "./spaces.md" with { type: "text" };
import teams from "./teams.md" with { type: "text" };
import whatIsAnthm from "./what-is-anthm.md" with { type: "text" };
import workflows from "./workflows.md" with { type: "text" };

/** English article sources, one per registry slug (missing or extra slugs fail typecheck). */
export const en: Record<HelpSlug, string> = {
  "what-is-anthm": whatIsAnthm,
  "first-chat": firstChat,
  concepts,
  "connect-github": connectGithub,
  "connect-hubspot": connectHubspot,
  "connect-zoominfo": connectZoominfo,
  "connect-linear": connectLinear,
  "connect-slack": connectSlack,
  connectors,
  navigation,
  chat,
  "chat-files": chatFiles,
  "agents-and-models": agentsAndModels,
  sharing,
  notifications,
  feedback,
  "past-chats": pastChats,
  spaces,
  "space-members": spaceMembers,
  knowledge,
  "knowledge-inbox": knowledgeInbox,
  "projects-and-teams": projectsAndTeams,
  teams,
  "space-settings": spaceSettings,
  build,
  "build-agents": buildAgents,
  skills,
  "data-sources": dataSources,
  workflows,
  brands,
  apps,
  settings,
  admin,
  "admin-users": adminUsers,
  "admin-models": adminModels,
  "admin-usage": adminUsage,
  "admin-company": adminCompany,
  "admin-license": adminLicense,
  "admin-feedback": adminFeedback,
  "admin-integrations": adminIntegrations,
  "admin-governance": adminGovernance,
  "admin-content-safety": adminContentSafety,
  "admin-access": adminAccess,
  "faq-access": faqAccess,
  "faq-limits": faqLimits,
  "faq-troubleshooting": faqTroubleshooting,
};
